import React, { useMemo } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import type { ChangeWorkGroup } from '../../../types/changes';
import { memberLabel, membersForGroup, workGroupOptions } from '../emergencyPolicyModel';

interface Props {
  areas: ChangeWorkGroup[];
  groupId: string;
  userId: number;
  onGroupChange: (groupId: string) => void;
  onUserChange: (userId: number) => void;
  /** Chamado com grupo e gestor já escolhidos (evita estado desatualizado no pai). */
  onPickComplete?: (groupId: number, userId: number) => void;
  disabled?: boolean;
  groupLabel?: string;
  userLabel?: string;
  /** Filtra grupos disponíveis no 1º select (ex.: só áreas ainda não incluídas). */
  filterGroups?: (area: ChangeWorkGroup) => boolean;
}

const ChangeGroupMemberSelects: React.FC<Props> = ({
  areas,
  groupId,
  userId,
  onGroupChange,
  onUserChange,
  onPickComplete,
  disabled = false,
  groupLabel = 'Grupo / área',
  userLabel = 'Gestor',
  filterGroups,
}) => {
  const groupOptions = useMemo(() => {
    const list = filterGroups ? areas.filter(filterGroups) : areas;
    return workGroupOptions(list);
  }, [areas, filterGroups]);

  const members = useMemo(
    () => membersForGroup(areas, Number(groupId) || 0),
    [areas, groupId],
  );

  return (
    <Row className="g-2 align-items-end">
      <Col md={6}>
        <Form.Label className="small mb-0">{groupLabel}</Form.Label>
        <Form.Select
          aria-label={groupLabel}
          disabled={disabled}
          value={groupId}
          onChange={(e) => {
            onGroupChange(e.target.value);
            onUserChange(0);
          }}
        >
          <option value="">Selecione o grupo</option>
          {groupOptions.map((opt) => (
            <option key={String(opt.value)} value={String(opt.value)}>
              {opt.label}
            </option>
          ))}
        </Form.Select>
      </Col>
      <Col md={6}>
        <Form.Label className="small mb-0">{userLabel}</Form.Label>
        <Form.Select
          aria-label={userLabel}
          disabled={disabled || !groupId}
          value={userId || ''}
          onChange={(e) => {
            const uid = Number(e.target.value) || 0;
            onUserChange(uid);
            const gid = Number(groupId) || 0;
            if (uid && gid) {
              onPickComplete?.(gid, uid);
            }
          }}
        >
          <option value="">
            {groupId
              ? members.length
                ? 'Selecione o gestor'
                : 'Nenhum membro — cadastre em Grupos'
              : 'Escolha o grupo primeiro'}
          </option>
          {members.map((member) => (
            <option key={member.user_id} value={member.user_id}>
              {memberLabel(member)}
              {member.is_manager ? ' · Gestor no grupo' : ''}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Row>
  );
};

export default ChangeGroupMemberSelects;
